module.exports = __webpack_public_path__ + "assets/media/video.c26b8710.mp4";